import { render } from "./AcademicWeekendHigh.vue?vue&type=template&id=3f07e6e1&scoped=true"
import script from "./AcademicWeekendHigh.vue?vue&type=script&lang=js"
export * from "./AcademicWeekendHigh.vue?vue&type=script&lang=js"

import "./AcademicWeekendHigh.vue?vue&type=style&index=0&id=3f07e6e1&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f07e6e1"]])

export default __exports__